import {
  CUSTOMERS_FEEDBACK_PAGE_REQUEST,
  CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST,
  CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK,
  CUSTOMERS_FEEDBACK_CHANGE_DATE,
  CUSTOMERS_FEEDBACK_MESSAGES_REQUEST,
  CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES,
  CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST,
  CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY,
  CUSTOMERS_FEEDBACK_SET_RECEIPT,
  CUSTOMERS_FEEDBACK_RECEIPT_REQUEST,
  CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE,
  CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE,
  CUSTOMERS_FEEDBACK_ON_CLICK_ROW,
} from './constants';

export function feedbackPageRequest() {
  return { type: CUSTOMERS_FEEDBACK_PAGE_REQUEST, payload: {} };
}

export function listFeedbackRequest(query, previousFeedback) {
  return {
    type: CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST,
    payload: { query, previousFeedback },
  };
}

export function setListFeedback(feedbacks) {
  return { type: CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK, payload: { feedbacks } };
}

export function changeDateFeedback(startDate, endDate) {
  return {
    type: CUSTOMERS_FEEDBACK_CHANGE_DATE,
    payload: { startDate, endDate },
  };
}

export function feedbackMessagesRequest(id) {
  return { type: CUSTOMERS_FEEDBACK_MESSAGES_REQUEST, payload: { id } };
}

export function setFeedbackMessages(feedbackMessages) {
  return {
    type: CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES,
    payload: { feedbackMessages },
  };
}

export function changeFormReply(message) {
  return { type: CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY, payload: { message } };
}

export function submitReplyRequest(data) {
  return { type: CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST, payload: { data } };
}

export function feedbackReceiptRequest(id) {
  return { type: CUSTOMERS_FEEDBACK_RECEIPT_REQUEST, payload: { id } };
}

export function onClickRow(feedback) {
  return { type: CUSTOMERS_FEEDBACK_ON_CLICK_ROW, payload: { feedback } };
}

export function setReceiptFeedback(transactionDetail) {
  return {
    type: CUSTOMERS_FEEDBACK_SET_RECEIPT,
    payload: { transactionDetail },
  };
}

export function setCurrentPage(currentPage) {
  return {
    type: CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return { type: CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE, payload: { totalPage } };
}
